// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import {Component, DestroyRef, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import { Router } from '@angular/router';
import {IIntegration, IIntegrationStatusResponse} from 'src/types/integrations';
import {TranslateService} from '@ngx-translate/core';
import {D3eService} from '../../../../services/d3e-service';
import {HeaderService} from '../../../header.service';
import {BehaviorSubject, combineLatest, EMPTY, Observable, timer} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-integration-card',
    templateUrl: './integration-card.component.html',
    styleUrls: ['./integration-card.component.scss'],
    standalone: false
})
export class IntegrationCardComponent implements OnChanges {
  @Input() config: IIntegration = null;
  @Input() setUpUrl = '';
  @Input() deleteEnabled = true;
  @Input() integrationType: string;
  @Input() disabled = false;
  @Input() showHealth = false;
  showMenu = false;
  @Output() delete = new EventEmitter<string>();

  private destroyRef = inject(DestroyRef);
  id$: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

  status$: Observable<IIntegrationStatusResponse> = combineLatest([
    this.headerService.orgSelectedChanged,
    this.id$,
    timer(0, 15000),
  ]).pipe(
    switchMap(([orgId, integrationId, n]: [string, string, number]) =>
      !integrationId ? EMPTY: this.d3eService.get_integration_status(integrationId, orgId == 'All' ? '' : orgId)),
    takeUntilDestroyed(this.destroyRef),
  );

  fSetup: string;
  fEdit: string;
  fDelete: string;
  constructor(
    private readonly router: Router,
    private readonly translate: TranslateService,
    private readonly d3eService: D3eService,
    private readonly headerService: HeaderService,
  ) {
    this.translate.get(['INTI_SETUP', 'INTI_EDIT', 'INTI_DELETE']).subscribe(vals => {
      this.fSetup = vals['INTI_SETUP'];
      this.fEdit = vals['INTI_EDIT'];
      this.fDelete = vals['INTI_DELETE'];
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('config' in changes && !!changes['config'].currentValue) {
      this.id$.next(changes['config'].currentValue.id);
    }
  }

  onClickSetUp() {
    this.router.navigate([this.setUpUrl, 'new']);
  }

  onClickEdit() {
    if (!this.config) {
      return;
    }
    this.router.navigate([this.setUpUrl, this.config.id]);
  }

  onClickDelete() {
    if (!this.config) {
      return;
    }
    this.delete.emit(this.config.id);
    this.showMenu = false;
  }

}
